import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGenerico } from '../../../_entities/FormGenerico';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DispositivosDisponibles } from '../../../_entities/Administracion/DispositivosDisponibles';
import { PanelCiudadano } from '../../../_entities/panelCiudadano/panelCiudadano';

@Injectable({
  providedIn: 'root'
})
export class PanelAdministracionService {

  constructor(private http:HttpClient) { }
  
	obtenerMarcas(): Observable<FormGenerico[]> {
		return this.http.get<FormGenerico[]>(`${environment.API_SECURITY}/api/PanelCiudadano/getMarcas`);
	}

	obtenerModelos(idMarca:number): Observable<FormGenerico[]> {
		return this.http.get<FormGenerico[]>(`${environment.API_SECURITY}/api/PanelCiudadano/getModelos/`+idMarca);
	}

	eliminarPanel(id:number) {
		return this.http.delete(`${environment.API_SECURITY}/api/PanelCiudadano/EliminarPanel/`+id);
	}

	agregarPanel(formData){
		return this.http.post(`${environment.API_SECURITY}/api/PanelCiudadano`,formData)
	}
	actualizarPanel(id,formData){
		return this.http.put(`${environment.API_SECURITY}/api/PanelCiudadano/`+id,formData)
	}

	
    /**Obtener Imeis */
    obtenerDispositivosDisponibles(): Observable<DispositivosDisponibles[]> {
		return this.http.get<DispositivosDisponibles[]>(environment.API_SECURITY + '/api/dispositivos/getbyestatus/1');
	  }
	  

	  obtenerPaneles(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano`);
	  }

	  obtenerPanel(id): Observable<PanelCiudadano> {
		return this.http.get<PanelCiudadano>(`${environment.API_SECURITY}/api/PanelCiudadano/`+id);
	  }

	  obtenerUltimaPaneles(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano/PanelMapa`);
	  }


	  obtenerPanelesAlarmados(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano/PanelAlarmado`);
	  }

	  obtenerPanelesHistorico(id,fechaInicio,fechaFinal): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano/Historico`,{params:{
			id:id,
			fechaInicio:fechaInicio,
			fechaFinal:fechaFinal
		}});
	  }

	  apagarAlarmaPanel(devIndex):Observable<any> {
		return this.http.get<any>(`${environment.API_SECURITY}/api/PanelCiudadano/apagarAlarma/`+devIndex);
	  }
}
